/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

export const Section: React.LegacyFunctionComponentWithChildren<{ isZeroState?: boolean }> = ({
  isZeroState,
  children,
  ...props
}) => {
  return (
    <section
      css={{
        padding: 'var(--cds-spacing-200)',
        background: isZeroState ? undefined : 'var(--cds-color-grey-25)',
        border: '1px solid',
        borderColor: 'var(--cds-color-grey-50)',
        borderRadius: 'var(--cds-spacing-50)',
      }}
      {...props}
    >
      {children}
    </section>
  );
};

export const SubSection: React.LegacyFunctionComponentWithChildren<{}> = ({ children, ...props }) => {
  return (
    <section
      css={{
        background: 'var(--cds-color-white-0)',
        border: '1px solid',
        borderColor: 'var(--cds-color-grey-300)',
        borderRadius: 'var(--cds-spacing-50)',
      }}
      {...props}
    >
      {children}
    </section>
  );
};
